import React from 'react';
import { object } from 'prop-types';
import classNames from 'classnames/bind';
import { Link } from 'react-router-dom';

import { withLabels } from 'containers/withLabels';

import Wysiwyg from 'components/Wysiwyg';

import IconEye from 'media/icons/eye.icon.svg';
import styles from './LatestBulletinsItem.module.scss';

const cx = classNames.bind(styles);

const LatestBulletinsItem = ({
  data: { title, short_description, alias },
  labels: { buttonDiscoverLabel },
}) => (
  <div className={cx('root')}>
    <h3 className={cx('title')}>{title}</h3>
    <Wysiwyg className={cx('description')} text={short_description} />
    <Link to={'/technical-bulletin' + alias} className={cx('link')}>
      <span className={cx('btn-icon')}>
        <IconEye />
      </span>
      <span className={cx('btn-text')}>{buttonDiscoverLabel}</span>
    </Link>
  </div>
);

LatestBulletinsItem.propTypes = {
  data: object.isRequired,
};

export default withLabels(LatestBulletinsItem);



// WEBPACK FOOTER //
// ./src/components/LatestBulletinsItem/LatestBulletinsItem.js